import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93ebad2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-tasks-board" }
const _hoisted_2 = { class: "dashboard-tasks-board__header" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "dashboard-tasks-board__title" }
const _hoisted_5 = {
  key: 0,
  class: "dashboard-tasks-board__badge bg-red-400 text-white"
}
const _hoisted_6 = {
  key: 0,
  class: "dashboard-tasks-board__empty"
}
const _hoisted_7 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
}
const _hoisted_8 = { class: "dashboard-task-card__top" }
const _hoisted_9 = { class: "dashboard-task-card__type" }
const _hoisted_10 = { class: "dashboard-task-card__meta" }
const _hoisted_11 = { class: "dashboard-task-card__date" }
const _hoisted_12 = { class: "dashboard-task-card__title" }
const _hoisted_13 = { class: "dashboard-task-card__row" }
const _hoisted_14 = { class: "text-gray-400" }
const _hoisted_15 = { class: "dashboard-task-card__row" }
const _hoisted_16 = { class: "text-gray-400" }


import {
  formatDashboardDate,
  formatDashboardDateTime,
} from "@/composables/useDashboardMain";
import type {
  DashboardDetailType,
  DashboardTaskItem,
} from "@/types/dashboard/DashboardTypes";
import type { RouteLocationRaw } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    tasks: null,
    totalCount: null,
    detailType: null,
    variant: null
  },
  emits: ["open-details"],
  setup(__props: any, { emit }: { emit: ({
  (event: "open-details", type: DashboardDetailType, title: string): void;
}), expose: any, slots: any, attrs: any }) {





function taskRoute(task: DashboardTaskItem): RouteLocationRaw {
  return {
    name: "ProcessUserDetails",
    params: { id: String(task.processUserId) },
  };
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.title), 1),
        (__props.totalCount)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.totalCount), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "dashboard-tasks-board__link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('open-details', __props.detailType, __props.title)))
      }, _toDisplayString(_ctx.$t("dashboard.tasks.viewAll")), 1)
    ]),
    (!__props.tasks.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("dashboard.tasks.empty")), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tasks, (task) => {
            return (_openBlock(), _createElementBlock("article", {
              key: task.processUserId,
              class: _normalizeClass(["dashboard-task-card", { 'dashboard-task-card--overdue': __props.variant === 'overdue' }])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(task.processTypeLabel || _ctx.$t("dashboard.emptyValue")), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (task.documentRegNumber)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: taskRoute(task),
                      class: "dashboard-task-card__doc-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" #" + _toDisplayString(task.documentRegNumber), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(formatDashboardDateTime)(task.createdAt)), 1)
              ]),
              _createElementVNode("h4", _hoisted_12, _toDisplayString(task.documentTitle || _ctx.$t("dashboard.emptyValue")), 1),
              _createElementVNode("p", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("dashboard.tasks.initiator")), 1),
                _createTextVNode(" " + _toDisplayString(task.initiatorName || _ctx.$t("dashboard.emptyValue")), 1)
              ]),
              _createElementVNode("p", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("dashboard.tasks.deadline")), 1),
                _createTextVNode(" " + _toDisplayString(_unref(formatDashboardDate)(task.deadline)), 1)
              ]),
              _createVNode(_component_router_link, {
                to: taskRoute(task),
                class: "dashboard-task-card__action"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("dashboard.tasks.viewDocument")), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ], 2))
          }), 128))
        ]))
  ]))
}
}

})